import { useEffect, useState } from "react";
import { MessageCircle, Phone, Clock, MapPin } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function Contato() {
  const [phone, setPhone] = useState("5531975548913");

  useEffect(() => {
    api
      .get("/public/contact")
      .then((r) => r.data?.whatsapp && setPhone(r.data.whatsapp))
      .catch(() => {});
  }, []);

  const waLink = `https://wa.me/${phone}?text=${encodeURIComponent(
    "Olá! Gostaria de informações sobre o programa Ressignificar Benefícios."
  )}`;

  function fmt(p) {
    const d = p.replace(/\D/g, "");
    if (d.length === 13) return `+${d.slice(0, 2)} (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
    return `+${d}`;
  }

  return (
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-14 md:py-20" data-testid="contact-page">
      <span className="inline-flex items-center gap-2 rounded-full border border-[#166534]/15 bg-[#F0FDF4] text-[#166534] text-xs font-semibold px-3 py-1.5">
        Fale com a gente
      </span>
      <h1 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter">
        Tire suas dúvidas pelo WhatsApp
      </h1>
      <p className="mt-4 text-neutral-700 max-w-xl">
        Nossa equipe está pronta para esclarecer tudo sobre o programa, benefícios e adesão.
      </p>

      <div className="mt-10 grid md:grid-cols-[1.1fr_0.9fr] gap-5">
        <div className="rounded-2xl border border-neutral-200 bg-white p-6 md:p-8">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#F0FDF4] text-[#166534]">
            <MessageCircle className="w-6 h-6" />
          </span>
          <h2 className="font-display mt-4 text-2xl font-extrabold">WhatsApp</h2>
          <p className="mt-2 text-neutral-600">
            Toque no botão abaixo para abrir uma conversa direto no WhatsApp.
          </p>
          <p className="mt-4 text-sm font-mono font-semibold text-[#166534]" data-testid="whatsapp-number">
            {fmt(phone)}
          </p>
          <a href={waLink} target="_blank" rel="noreferrer">
            <Button
              data-testid="whatsapp-button"
              className="mt-5 rounded-full bg-[#166534] hover:bg-[#14532d] hover:text-white text-white h-12 px-6 text-base"
            >
              Falar no WhatsApp
            </Button>
          </a>
        </div>

        <div className="rounded-2xl bg-[#052E16] text-white p-6 md:p-8">
          <h3 className="font-display text-xl font-bold">Horário de atendimento</h3>
          <ul className="mt-4 space-y-3 text-sm text-emerald-100/90">
            <li className="flex gap-2">
              <Clock className="w-4 h-4 text-emerald-300 mt-0.5" />
              Segunda a sexta · 09h às 18h
            </li>
            <li className="flex gap-2">
              <Clock className="w-4 h-4 text-emerald-300 mt-0.5" />
              Sábados · 09h às 13h
            </li>
            <li className="flex gap-2">
              <Phone className="w-4 h-4 text-emerald-300 mt-0.5" />
              Preferimos WhatsApp — resposta mais rápida.
            </li>
            <li className="flex gap-2">
              <MapPin className="w-4 h-4 text-emerald-300 mt-0.5" />
              Atendimento 100% online e por telefone.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
